import { memo } from 'react';

import { OButton, OModal } from '@src/shared';

import useViewLayoutModal from './useViewLayoutModal';

import { LAYOUT_OPTIONS } from '@src/constants';

import './viewLayoutModal.scss';

const ViewLayoutModal = () => {
  const { selectedOption, isViewLayoutOpen, handleApply, handleCloseModal, setSelectedOption } = useViewLayoutModal();

  return (
    <OModal
      isOpen={isViewLayoutOpen}
      classes={{
        container: 'layout-modal',
        closeIcon: 'close-icon',
      }}
      title="Change layout"
      onClose={handleCloseModal}
      hasBackdrop
    >
      <div className="container-layout">
        {LAYOUT_OPTIONS.map((option) => (
          <div
            key={option.value}
            className={`action-menu ${selectedOption === option.value ? 'clicked' : ''}`}
            onClick={() => setSelectedOption(option.value)}
          >
            <label className="radio-label">
              <input
                type="radio"
                value={option.value}
                checked={selectedOption === option.value}
                onChange={() => setSelectedOption(option.value)}
              />
              {option.text}
            </label>
            <img src={option.img} alt={option.value} className="layout-img" />
          </div>
        ))}
      </div>
      <div className="button-container">
        <OButton
          text="Apply"
          size="small"
          classes={{
            container: 'button-apply',
          }}
          onClick={handleApply}
        />
      </div>
    </OModal>
  );
};

export default memo(ViewLayoutModal);
